import { gql } from '@apollo/client';

const GET_CLASSIFICATION_PERFORMANCE_ITEM_REPORT = gql`
  query GetClassificationPerformanceItemReport($classificationPerformanceItemId: Int!) {
    classificationPerformanceItemsReport(
      classificationPerformanceItemId: $classificationPerformanceItemId
    ) {
      MeasurementCalculationName
      QuarterlyReportData {
        Quarter {
          Year
          QuarterNum
          DisplayName
        }
        Average
      }
    }
  }
`;

export default GET_CLASSIFICATION_PERFORMANCE_ITEM_REPORT;
